import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import Select from "react-select";
import { styleSelect } from "../../constants/customStyles";
import { saveProduct } from "../../actions/ProductActions";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import Mobilemenu from "../../layouts/mobile-menu";

function AddProduct() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllProductCategory(null, 99999, ''));
    }, []);
    const productCategories = useSelector(state => state?.productCategory?.productCategories?.data)
    const loading = useSelector(state => state?.loading?.loading);

    const [name, setName] = useState('');
    const [costPrice, setCostPrice] = useState('');
    const [salePrice, setSalePrice] = useState('');
    const [variant, setVariant] = useState('');
    const [type, setType] = useState('');
    const [productCategory, setProductCategory] = useState('');
    const [productType, setProductType] = useState('');

    const save = () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
                cost_price: costPrice,
                sale_price: salePrice,
                // item_code: itemCode,
                product_type: type,
                product_category: productCategory
            }
            dispatch(saveProduct(data, navigate));
        }
        // window.location.href = ('/state');
    }

    const Options = [
        { value: 'goods', label: 'Spare Parts' },
        { value: 'service', label: 'Repairs' },
    ]


    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Add Product
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12">
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Name :</label>
                                        <input id="name" name="name" onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Enter Name" />
                                    </div>
                                    <div className="g-col-12 g-col-md-6">
                                        <label for="crud-form-1" className="form-label">Product Category</label>
                                        <Select className="z-50" styles={styleSelect} onChange={(e) => setProductCategory(e.id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.product_category_id}`} options={productCategories && productCategories.length > 0 ? productCategories : []} />
                                    </div>
                                    {/* <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">List Price :</label>
                                        <input id="mobile" name="mobile" type="text" value={salePrice} onChange={(e) => setSalePrice(e.target.value)} className="form-control" placeholder="Enter Sale Price" />
                                    </div> */}
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="email" className="form-label">Cost Price :</label>
                                        <input id="email" name="email" type="text" onChange={(e) => setCostPrice(e.target.value)} className="form-control" placeholder="Enter Cost Price" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">Sale Price :</label>
                                        <input id="mobile" name="mobile" type="text" onChange={(e) => setSalePrice(e.target.value)} className="form-control" placeholder="Enter Sale Price" />
                                    </div>
                                    <div className="g-col-12 g-col-md-6">
                                        <label for="crud-form-1" className="form-label">Product Type :</label>
                                        <Select styles={styleSelect} onChange={(e) => setType(e.value)} options={Options} />
                                    </div>
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/products')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddProduct;